module.exports = __webpack_public_path__ + "img/4_5_combo.52103c20.png";